export default __webpack_public_path__ + "bde412629be48b8960d9d76ebe675e46.png";